import * as d3 from "d3";
import { Types } from "../../utils/nodeTypes";

const ResizeTools = {
  expandX: function (d) {
    if(d.type == new Types().InputCana){
      this.expandCaneX(d)
    }
    else if(d.type == new Types().Milling){
      this.expandMillingX(d)
    }
    else if(d.type == new Types().AreaJoker){
      this.expandAreaJokerX(d)
    }
    else if(d.type == new Types().Rectangle){
      this.expandRectangleX(d)
    }
    else
    {
      d3.selectAll(`#${d.idName} > image`)
      .raise()
      .attr("height", d.height)
    }
  },

  expandY: function (d) {
    if(d.type == new Types().InputCana){
      this.expandCaneY(d)
    }
    else if(d.type == new Types().Milling){
      this.expandMillingY(d)
    }
    else if(d.type == new Types().AreaJoker){
      this.expandAreaJokerY(d)
    }
    else if(d.type == new Types().Rectangle){
      this.expandRectangleY(d)
    }
    else
    {
      d3.selectAll(`#${d.idName} > image`)
      .raise()
      .attr("width", d.width)  
    }
  },

  expandCaneY: function (d) {
    d3.selectAll(`#${d.idName} > image`)
      .raise()
      .attr("height", d.height - 30)

    d3.selectAll(`#${d.idName} > circle`)
      .raise()
      .attr("cy", d.yDot())

    d3.selectAll(`#${d.idName} > rect`)
      .raise()
      .attr("y", (d) => d.yRect())

    d3.selectAll(`#${d.idName} > text`)
      .raise()
      .attr("y", d.yText())

    d.connectionPack = d.connectionPack.filter(point => d.decorator.ctrConnection.isAlive(point.conn))
    d.connectionPack.forEach(point => point.conn.moveFirstPoint({x: d.xDot(), y: d.yDot()}));
  },

  expandCaneX: function (d) {
    d3.selectAll(`#${d.idName} > image`)
    .raise()
    .attr("width", d.width)

    d3.selectAll(`#${d.idName} > circle`)
    .raise()
    .attr("cx", d.xDot())

    d3.selectAll(`#${d.idName} > rect`)
      .raise()
      .attr("x", (d) => d.xRect())

    d3.selectAll(`#${d.idName} > text`)
      .raise()
      .attr("x", d.xText())

    d.connectionPack = d.connectionPack.filter(point => d.decorator.ctrConnection.isAlive(point.conn))
    d.connectionPack.forEach(point => point.conn.moveFirstPoint({x: d.xDot(), y: d.yDot()}));
  },

  expandMillingY: function (d) {
    d3.selectAll(`#${d.idName} > image`)
      .raise()
      .attr("height", d.height)

    let conn = new Array();
    if(d.connectionPack.length > 0){
      d.connectionPack = d.connectionPack.filter(point => d.decorator.ctrConnection.isAlive(point.conn))
      d.connectionPack.forEach(point => {
        let isSelected = conn.includes(point.conn)
        if(!isSelected){
          let dot = d.decorator.getPointPosition(d, point.dot)
          point.conn.moveFirstPoint({x: dot[0].x, y: dot[0].y})
        }
      });
    }
  },

  expandMillingX: function (d) {
    d3.selectAll(`#${d.idName} > image`)
    .raise()
    .attr("width", d.width)

    let conn = new Array();
    if(d.connectionPack.length > 0){
      d.connectionPack = d.connectionPack.filter(point => d.decorator.ctrConnection.isAlive(point.conn))
      d.connectionPack.forEach(point => {
        let isSelected = conn.includes(point.conn)
        if(!isSelected){
          let dot = d.decorator.getPointPosition(d, point.dot)
          point.conn.moveFirstPoint({x: dot[0].x, y: dot[0].y})
        }
      });
    }
  },

  expandAreaJokerX: function (d) {
    d3.select(`#${d.idName} > rect`)
      .raise()
      .attr("width", d.width)

      d.fontSize = ((d.width/6) / d.areaName.length)* 10
    // d.fontSize = d.width / (0.056 * 9 * d.areaName.length)

    d3.select(`#${d.idName} > text`)
      .style("font-size", `${d.fontSize}px`)
  },
  
  expandAreaJokerY: function (d) {
    d3.select(`#${d.idName} > rect`)
      .raise()
      .attr("height", d.height)

    d3.select(`#${d.idName} > text`)
      .raise()
      .attr("y", d.yText())
  },

  expandRectangleX: function (d) {
    d3.select(`#${d.idName} > rect`)
      .raise()
      .attr("width", d.width)
  },

  expandRectangleY: function (d) {
    d3.select(`#${d.idName} > rect`)
      .raise()
      .attr("height", d.height)
  },
}

export default ResizeTools